import React from "react";

function PortalFormPanel({ icon, title, hint, children }) {
  return (
    <section className="cportal-form-panel">
      <header className="cportal-form-panel-head">
        {icon ? <span className="cportal-form-panel-icon">{icon}</span> : null}
        <div className="cportal-form-panel-heading">
          <h2 className="cportal-form-panel-title">{title}</h2>
          {hint ? <p className="cportal-form-panel-hint">{hint}</p> : null}
        </div>
      </header>
      {children}
    </section>
  );
}

export default PortalFormPanel;
